import { array, option } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

import { getOrFalse } from '@mews/fp';

import { getReservationIdsFromQuery } from '../../../../modules/app/selectors';
import { parentSelector } from '../../../../selectors/parentSelector';
import { ApplicationState } from '../../../../types';
import { Confirmation, ConfirmationReservation } from '../types';

export const getConfirmation = createSelector<ApplicationState, ApplicationState, Confirmation>(
    parentSelector,
    get('confirmation')
);

export const getConfirmedReservations = createSelector(
    getConfirmation,
    getReservationIdsFromQuery,
    (confirmation, reservationIds) =>
        pipe(
            confirmation?.reservations,
            option.fromNullable,
            option.map((reservations) => {
                if (reservationIds == null || array.isEmpty(reservationIds)) {
                    return reservations;
                }
                return pipe(
                    reservations,
                    array.filter((reservation) => reservationIds.includes(reservation.id))
                );
            }),
            option.getOrElse<ConfirmationReservation[]>(() => [])
        )
);

export const getConfirmedReservationIds = createSelector(
    getConfirmedReservations,
    array.map((reservation) => reservation.id)
);

export const hasCheckoutPreviousStep = createSelector(getConfirmation, getOrFalse('hasCheckoutPreviousStep'));
